import React, { useState, useEffect } from "react";

import "./Styles.css";

const InputSelect = ({ typeOption = 'Array', options = [], msgOption, required, name, id, disabled = false, containerStyle = "container-select", styleInput = "input-select", label, onChange, ...props }) => {

    const [option, setOption] = useState([])

    useEffect(() => {
        if(typeOption === 'Array'){
            if(options.length > 0){
                let itemOption = options.map((data, i) => <option key={i} value={data}>{data}</option>);
                setOption(itemOption);
            }
        }else{
            let itemOption = options.map((data, i) => <option key={i} value={data.id}>{data.value}</option>);
            setOption(itemOption);
        }
    }, [])

    useEffect(() => {
        if(typeOption === 'Array'){
            if(options.length > 0){
                let itemOption = options.map((data, i) => <option key={i} value={data}>{data}</option>);
                setOption(itemOption);
            }else{
                setOption([])
            }
        }else{
            let itemOption = options.map((data, i) => <option key={i} value={data.id}>{data.value}</option>);
            setOption(itemOption);
        }
    }, [options])

    const removeError = (el) => {
        let target = el.target
        target.classList.remove("error")
    }

    return (
        <div className={[containerStyle]}>
            {label ? <label className="label-select">{label}</label> : null}
            <select name={name} required={required} disabled={disabled} id={id} className={[styleInput]} {...props} onChange={(el) => { removeError(el); onChange ? onChange(el) : console.log('') }}>
                <option value="">{msgOption}</option>
                {option}
            </select>
        </div>
    )
}

export default InputSelect